export enum PaymentMethodEnum {
  card = 'card',
  achDirectDebit = 'achDirectDebit',
  cash = 'cash',
  check = 'check',
  free = 'free',
  relatedOrder = 'relatedOrder',
  bankTransfer = 'bankTransfer',
  onAccount = 'onAccount',
  // PayMongo's e-wallet rail. `PayMongoPaymentGateway.parseCheckoutPaidEvent` derives this from
  // the checkout session's own `payment_method_used` (observed live against PayMongo's test API
  // for SA-9 — the field DOES exist at checkout-session level, contrary to one of PayMongo's own
  // contradicting doc pages) and defaults to `card` for every other/absent value.
  gcash = 'gcash',
}
